/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Alerts_Go_To_DeliveryInputs */

const he_account_alerts_go_to_delivery = /** @type {(inputs: Account_Alerts_Go_To_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לאן נשלחות ההתראות?`)
};

const en_account_alerts_go_to_delivery = /** @type {(inputs: Account_Alerts_Go_To_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where are alerts delivered?`)
};

/**
* | output |
* | --- |
* | "Where are alerts delivered?" |
*
* @param {Account_Alerts_Go_To_DeliveryInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_alerts_go_to_delivery = /** @type {((inputs?: Account_Alerts_Go_To_DeliveryInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Alerts_Go_To_DeliveryInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_alerts_go_to_delivery(inputs)
	return en_account_alerts_go_to_delivery(inputs)
});